export function checkDeviceWidth () {
  let res;
  if (window.matchMedia('(min-width: 641px)').matches) {
    res = 'desktop';
  } else {
    res = 'mobile';
  }
  return res;
}


window.addEventListener('resize', function() {
  checkDeviceWidth();
});
